// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Powered by Promo Amp`
};

const de_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Unterstützt von Promo Amp`
};

const es_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Desarrollado por Promo Amp`
};

const fr_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Propulsé par Promo Amp`
};

const fi_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Palvelun tarjoaa Promo Amp`
};

const hi_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `प्रोमो एम्प द्वारा संचालित`
};

const ja_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Promo Amp提供`
};

const nl_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Mogelijk gemaakt door Promo Amp`
};

const pt_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Desenvolvido por Promo Amp`
};

const ro_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Cu sprijinul Promo Amp`
};

const th_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `ขับเคลื่อนโดย Promo Amp`
};

const ur_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Promo Amp کی طرف سے طاقت ور`
};

const zh_hant1_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `由 Promo Amp 強力驅動`
};

const da_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Leveret af Promo Amp`
};

const it_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Powered by Promo Amp`
};

const vn_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Được hỗ trợ bởi Promo Amp`
};

const ko_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Promo Amp 제공`
};

const tr_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Promo Amp tarafından desteklenmektedir`
};

const lv_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Darbina Promo Amp`
};

const ar_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `مدعوم من Promo Amp`
};

const bs_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Pokreće Promo Amp`
};

const sl_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Poganja Promo Amp`
};

const id_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Didukung oleh Promo Amp`
};

const sv_widget_powered_by = /** @type {(inputs: {}) => string} */ () => {
	return `Drivs av Promo Amp`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_powered_by = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_powered_by(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_powered_by", locale)
	if (locale === "en") return en_widget_powered_by(inputs)
	if (locale === "de") return de_widget_powered_by(inputs)
	if (locale === "es") return es_widget_powered_by(inputs)
	if (locale === "fr") return fr_widget_powered_by(inputs)
	if (locale === "fi") return fi_widget_powered_by(inputs)
	if (locale === "hi") return hi_widget_powered_by(inputs)
	if (locale === "ja") return ja_widget_powered_by(inputs)
	if (locale === "nl") return nl_widget_powered_by(inputs)
	if (locale === "pt") return pt_widget_powered_by(inputs)
	if (locale === "ro") return ro_widget_powered_by(inputs)
	if (locale === "th") return th_widget_powered_by(inputs)
	if (locale === "ur") return ur_widget_powered_by(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_powered_by(inputs)
	if (locale === "da") return da_widget_powered_by(inputs)
	if (locale === "it") return it_widget_powered_by(inputs)
	if (locale === "vn") return vn_widget_powered_by(inputs)
	if (locale === "ko") return ko_widget_powered_by(inputs)
	if (locale === "tr") return tr_widget_powered_by(inputs)
	if (locale === "lv") return lv_widget_powered_by(inputs)
	if (locale === "ar") return ar_widget_powered_by(inputs)
	if (locale === "bs") return bs_widget_powered_by(inputs)
	if (locale === "sl") return sl_widget_powered_by(inputs)
	if (locale === "id") return id_widget_powered_by(inputs)
	if (locale === "sv") return sv_widget_powered_by(inputs)
	return "widget_powered_by"
};